// // // import React, { useState } from "react";
// // // import axios from "axios";
// // // import "./popup.css"; // optional

// // // const Popup = ({ onClose }) => {
// // //   const [formData, setFormData] = useState({
// // //     name: "",
// // //     mobile: "",
// // //     email: "",
// // //     place: "",
// // //   });

// // //   const handleChange = (e) => {
// // //     setFormData({ ...formData, [e.target.name]: e.target.value });
// // //   };

// // //   const handleSubmit = async (e) => {
// // //     e.preventDefault();

// // //     try {
// // //       // Send form data to backend
// // //       await axios.post(process.env.REACT_APP_API_URL+"/admin/eventposter", formData);

// // //       alert("✅ Thank you! Your details have been submitted.");
// // //       setFormData({ name: "", mobile: "", email: "", place: "" });
// // //       onClose();
// // //     } catch (err) {
// // //       console.error("❌ Error submitting form:", err);
// // //       alert("Something went wrong. Please try again.");
// // //     }
// // //   };

// // //   return (
// // //     <div className="popup-overlay">
// // //       <div className="popup-content">
// // //         {/* Close Button */}
// // //         <button className="popup-close" onClick={onClose}>
// // //           ✖
// // //         </button>

// // //         <div className="popup-body">
// // //           {/* Image Section */}
// // //           <div className="popup-image">
// // //             <img src="/dro2.jpg" alt="Popup Drone" />
// // //           </div>

// // //           {/* Form Section */}
// // //           <div className="popup-form">
// // //             <h2>Enter Your Details</h2>
// // //             <form onSubmit={handleSubmit}>
// // //               <input
// // //                 type="text"
// // //                 name="name"
// // //                 placeholder="Full Name"
// // //                 value={formData.name}
// // //                 onChange={handleChange}
// // //                 required
// // //               />
// // //               <input
// // //                 type="tel"
// // //                 name="mobile"
// // //                 placeholder="Mobile Number"
// // //                 value={formData.mobile}
// // //                 onChange={handleChange}
// // //                 required
// // //               />
// // //               <input
// // //                 type="email"
// // //                 name="email"
// // //                 placeholder="Email Address"
// // //                 value={formData.email}
// // //                 onChange={handleChange}
// // //                 required
// // //               />
// // //               <input
// // //                 type="text"
// // //                 name="place"
// // //                 placeholder="Place"
// // //                 value={formData.place}
// // //                 onChange={handleChange}
// // //                 required
// // //               />
// // //               <button type="submit" className="popup-submit">
// // //                 Submit
// // //               </button>
// // //             </form>
// // //           </div>
// // //         </div>
// // //       </div>
// // //     </div>
// // //   );
// // // };

// // // export default Popup;


// // // import React, { useState, useEffect } from "react";
// // // import axios from "axios";
// // // import "./popup.css";

// // // const Popup = ({ onClose }) => {
// // //   const [formData, setFormData] = useState({
// // //     name: "",
// // //     mobile: "",
// // //     email: "",
// // //     place: "",
// // //   });

// // //   const [posterImage, setPosterImage] = useState(null);

// // //   useEffect(() => {
// // //     const fetchPoster = async () => {
// // //       try {
// // //         const response = await axios.get(process.env.REACT_APP_API_URL+"/admin/eventposter");
// // //         if (response.data.active && response.data.image) {
// // //           // Set image URL from backend with image ID
// // //           setPosterImage(process.env.REACT_APP_API_URL+`/admin/eventposter/image/${response.data.image.id}`);
// // //         } else {
// // //           // No image found, close popup
// // //           onClose();
// // //         }
// // //       } catch (error) {
// // //         console.error("Error fetching event poster:", error);
// // //         onClose();
// // //       }
// // //     };

// // //     fetchPoster();
// // //   }, [onClose]);

// // //   const handleChange = (e) => {
// // //     setFormData({ ...formData, [e.target.name]: e.target.value });
// // //   };

// // //   const handleSubmit = async (e) => {
// // //     e.preventDefault();

// // //     try {
// // //       await axios.post(process.env.REACT_APP_API_URL+"/admin/eventposter", formData);
// // //       alert("✅ Thank you! Your details have been submitted.");
// // //       setFormData({ name: "", mobile: "", email: "", place: "" });
// // //       onClose();
// // //     } catch (err) {
// // //       console.error("❌ Error submitting form:", err);
// // //       alert("Something went wrong. Please try again.");
// // //     }
// // //   };

// // //   // Render nothing if no image URL is ready yet
// // //   if (!posterImage) return null;

// // //   return (
// // //     <div className="popup-overlay">
// // //       <div className="popup-content">
// // //         <button className="popup-close" onClick={onClose}>
// // //           ✖
// // //         </button>
// // //         <div className="popup-body">
// // //           <div className="popup-image">
// // //             <img src={posterImage} alt="Event Poster" />
// // //           </div>
// // //           <div className="popup-form">
// // //             <h2>Enter Your Details</h2>
// // //             <form onSubmit={handleSubmit}>
// // //               <input
// // //                 type="text"
// // //                 name="name"
// // //                 placeholder="Full Name"
// // //                 value={formData.name}
// // //                 onChange={handleChange}
// // //                 required
// // //               />
// // //               <input
// // //                 type="tel"
// // //                 name="mobile"
// // //                 placeholder="Mobile Number"
// // //                 value={formData.mobile}
// // //                 onChange={handleChange}
// // //                 required
// // //               />
// // //               <input
// // //                 type="email"
// // //                 name="email"
// // //                 placeholder="Email Address"
// // //                 value={formData.email}
// // //                 onChange={handleChange}
// // //                 required
// // //               />
// // //               <input
// // //                 type="text"
// // //                 name="place"
// // //                 placeholder="Place"
// // //                 value={formData.place}
// // //                 onChange={handleChange}
// // //                 required
// // //               />
// // //               <button type="submit" className="popup-submit">
// // //                 Submit
// // //               </button>
// // //             </form>
// // //           </div>
// // //         </div>
// // //       </div>
// // //     </div>
// // //   );
// // // };

// // // export default Popup;

// // // import React, { useState, useEffect } from "react";
// // // import axios from "axios";
// // // import "./popup.css";

// // // const Popup = ({ onClose }) => {
// // //   const [formData, setFormData] = useState({
// // //     name: "",
// // //     mobile: "",
// // //     email: "",
// // //     place: "",
// // //   });

// // //   const [posterImage, setPosterImage] = useState(null);

// // //   useEffect(() => {
// // //     const fetchPoster = async () => {
// // //       try {
// // //         const res = await axios.get(process.env.REACT_APP_API_URL+"/admin/eventposter/active");
// // //         if (res.data.active && res.data.image) {
// // //           setPosterImage(process.env.REACT_APP_API_URL+`/admin/eventposter/${res.data.image.id}`);
// // //         } else {
// // //           onClose(); // No active poster
// // //         }
// // //       } catch (err) {
// // //         console.error(err);
// // //         onClose();
// // //       }
// // //     };
// // //     fetchPoster();
// // //   }, [onClose]);

// // //   const handleChange = (e) => {
// // //     setFormData({ ...formData, [e.target.name]: e.target.value });
// // //   };

// // //   const handleSubmit = async (e) => {
// // //     e.preventDefault();
// // //     try {
// // //       await axios.post(process.env.REACT_APP_API_URL+"/admin/eventposter/submit", formData);
// // //       alert("✅ Thank you! Your details have been submitted.");
// // //       setFormData({ name: "", mobile: "", email: "", place: "" });
// // //       onClose();
// // //     } catch (err) {
// // //       console.error(err);
// // //       alert("❌ Something went wrong.");
// // //     }
// // //   };

// // //   if (!posterImage) return null;

// // //   return (
// // //     <div className="popup-overlay">
// // //       <div className="popup-content">
// // //         <button className="popup-close" onClick={onClose}>✖</button>
// // //         <div className="popup-body">
// // //           <div className="popup-image">
// // //             <img src={posterImage} alt="Event Poster" />
// // //           </div>
// // //           <div className="popup-form">
// // //             <h2>Enter Your Details</h2>
// // //             <form onSubmit={handleSubmit}>
// // //               <input type="text" name="name" placeholder="Full Name" value={formData.name} onChange={handleChange} required />
// // //               <input type="tel" name="mobile" placeholder="Mobile Number" value={formData.mobile} onChange={handleChange} required />
// // //               <input type="email" name="email" placeholder="Email Address" value={formData.email} onChange={handleChange} required />
// // //               <input type="text" name="place" placeholder="Place" value={formData.place} onChange={handleChange} required />
// // //               <button type="submit" className="popup-submit">Submit</button>
// // //             </form>
// // //           </div>
// // //         </div>
// // //       </div>
// // //     </div>
// // //   );
// // // };

// // // export default Popup;
// // import React, { useState, useEffect } from "react";
// // import axios from "axios";
// // import "./popup.css";

// // const Popup = ({ onClose }) => {
// //   const [formData, setFormData] = useState({
// //     name: "",
// //     mobile: "",
// //     email: "",
// //     place: "",
// //   });

// //   const [posterImage, setPosterImage] = useState(null);

// //   // Fetch poster from event poster backend
// //   useEffect(() => {
// //     const fetchPoster = async () => {
// //       try {
// //         const res = await axios.get(process.env.REACT_APP_API_URL+"/admin/eventposter"); // your poster route
// //         if (res.data.length > 0) {
// //           const imageId = res.data[0]._id; // first poster or implement active logic
// //           setPosterImage(process.env.REACT_APP_API_URL+`/admin/eventposter/${imageId}`);
// //         }
// //       } catch (err) {
// //         console.error("Error fetching poster:", err);
// //       }
// //     };
// //     fetchPoster();
// //   }, []);

// //   const handleChange = (e) => {
// //     setFormData({ ...formData, [e.target.name]: e.target.value });
// //   };

// //   const handleSubmit = async (e) => {
// //     e.preventDefault();

// //     try {
// //       // ✅ Submit user details to your separate backend route
// //       await axios.post(process.env.REACT_APP_API_URL+"/admineventposter", formData);

// //       alert("✅ Thank you! Your details have been submitted.");
// //       setFormData({ name: "", mobile: "", email: "", place: "" });
// //       onClose();
// //     } catch (err) {
// //       console.error("❌ Error submitting form:", err);
// //       alert("Something went wrong. Please try again.");
// //     }
// //   };

// //   return (
// //     <div className="popup-overlay">
// //       <div className="popup-content">
// //         <button className="popup-close" onClick={onClose}>✖</button>
// //         <div className="popup-body">
// //           <div className="popup-image">
// //             {posterImage && <img src={posterImage} alt="Event Poster" />}
// //           </div>
// //           <div className="popup-form">
// //             <h2>Enter Your Details</h2>
// //             <form onSubmit={handleSubmit}>
// //               <input type="text" name="name" placeholder="Full Name" value={formData.name} onChange={handleChange} required />
// //               <input type="tel" name="mobile" placeholder="Mobile Number" value={formData.mobile} onChange={handleChange} required />
// //               <input type="email" name="email" placeholder="Email Address" value={formData.email} onChange={handleChange} required />
// //               <input type="text" name="place" placeholder="Place" value={formData.place} onChange={handleChange} required />
// //               <button type="submit" className="popup-submit">Submit</button>
// //             </form>
// //           </div>
// //         </div>
// //       </div>
// //     </div>
// //   );
// // };

// // export default Popup;

// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import "./popup.css";

// const Popup = ({ onClose }) => {
//   const [formData, setFormData] = useState({
//     name: "",
//     mobile: "",
//     email: "",
//     place: "",
//   });

//   const [posterImage, setPosterImage] = useState(null);

//   // Fetch poster from backend
//   useEffect(() => {
//     const fetchPoster = async () => {
//       try {
//         const res = await axios.get(process.env.REACT_APP_API_URL+"/admin/eventposter"); // your poster route
//         if (res.data.length > 0) {
//           const imageId = res.data[0]._id; // first poster or implement active logic
//           setPosterImage(process.env.REACT_APP_API_URL+`/admin/eventposter/${imageId}`);
//         } else {
//           setPosterImage(null); // No poster, hide everything
//         }
//       } catch (err) {
//         console.error("Error fetching poster:", err);
//         setPosterImage(null);
//       }
//     };
//     fetchPoster();
//   }, []);

//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     try {
//       await axios.post(process.env.REACT_APP_API_URL+"/admineventposter", formData);

//       alert("✅ Thank you! Your details have been submitted.");
//       setFormData({ name: "", mobile: "", email: "", place: "" });
//       onClose();
//     } catch (err) {
//       console.error("❌ Error submitting form:", err);
//       alert("Something went wrong. Please try again.");
//     }
//   };

//   // If no poster, render nothing
//   if (!posterImage) return null;

//   return (
//     <div className="popup-overlay">
//       <div className="popup-content">
//         {/* Close Button */}
//         <button className="popup-close" onClick={onClose}>✖</button>

//         <div className="popup-body">
//           {/* Poster Image */}
//           <div className="popup-image">
//             <img src={posterImage} alt="Event Poster" />
//           </div>

//           {/* Form */}
//           <div className="popup-form">
//             <h2>Enter Your Details</h2>
//             <form onSubmit={handleSubmit}>
//               <input
//                 type="text"
//                 name="name"
//                 placeholder="Full Name"
//                 value={formData.name}
//                 onChange={handleChange}
//                 required
//               />
//               <input
//                 type="tel"
//                 name="mobile"
//                 placeholder="Mobile Number"
//                 value={formData.mobile}
//                 onChange={handleChange}
//                 required
//               />
//               <input
//                 type="email"
//                 name="email"
//                 placeholder="Email Address"
//                 value={formData.email}
//                 onChange={handleChange}
//                 required
//               />
//               <input
//                 type="text"
//                 name="place"
//                 placeholder="Place"
//                 value={formData.place}
//                 onChange={handleChange}
//                 required
//               />
//               <button type="submit" className="popup-submit">Submit</button>
//             </form>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Popup;

import React, { useState, useEffect } from "react";
import axios from "axios";
import "./popup.css";

const Popup = ({ onClose }) => {
  const [formData, setFormData] = useState({
    name: "",
    phone: "", // matches backend
    mail: "",  // matches backend
    place: "",
  });

  const [posterImage, setPosterImage] = useState(null);

  // Fetch poster image from backend
  useEffect(() => {
    const fetchPoster = async () => {
      try {
        const res = await axios.get(process.env.REACT_APP_API_URL+"/admin/eventposter"); // poster route
        if (res.data.length > 0) {
          const imageId = res.data[0]._id;
          setPosterImage(process.env.REACT_APP_API_URL+`/admin/eventposter/${imageId}`);
        } else {
          setPosterImage(null);
        }
      } catch (err) {
        console.error("Error fetching poster:", err);
        setPosterImage(null);
      }
    };
    fetchPoster();
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(process.env.REACT_APP_API_URL+"/admineventposter", formData);
      alert("✅ Thank you! Your details have been submitted.");
      setFormData({ name: "", phone: "", mail: "", place: "" });
      onClose();
    } catch (err) {
      console.error("Error submitting form:", err);
      alert("❌ Something went wrong. Please try again.");
    }
  };

  // Hide popup completely if no poster
  if (!posterImage) return null;

  return (
    <div className="popup-overlay">
      <div className="popup-content">
        <button className="popup-close" onClick={onClose}>✖</button>
        <div className="popup-body">
          <div className="popup-image">
            <img src={posterImage} alt="Event Poster" />
          </div>
          <div className="popup-form">
            <h2>Enter Your Details</h2>
            <form onSubmit={handleSubmit}>
              <input
                type="text"
                name="name"
                placeholder="Full Name"
                value={formData.name}
                onChange={handleChange}
                required
              />
              <input
                type="tel"
                name="phone"
                placeholder="Mobile Number"
                value={formData.phone}
                onChange={handleChange}
                required
              />
              <input
                type="email"
                name="mail"
                placeholder="Email Address"
                value={formData.mail}
                onChange={handleChange}
                required
              />
              <input
                type="text"
                name="place"
                placeholder="Place"
                value={formData.place}
                onChange={handleChange}
                required
              />
              <button type="submit" className="popup-submit">Submit</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Popup;

